import type { QueryClient } from "@tanstack/react-query"
import { MAIN_DEX } from "../marketIdentity"
import { hyperliquidQueryKeys } from "../queries"
import type { HLDexName } from "../types"

export async function invalidateTradeQueries(
  queryClient: QueryClient,
  address?: `0x${string}`,
  dex: HLDexName = MAIN_DEX
) {
  // Trading-balance queries derive their source from the long-lived abstraction
  // query, so that dependency must be stale before any balance refetch starts.
  await queryClient.invalidateQueries({
    queryKey: hyperliquidQueryKeys.userAbstraction(address),
  })

  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: hyperliquidQueryKeys.account(address, dex),
    }),
    queryClient.invalidateQueries({
      queryKey: hyperliquidQueryKeys.tradingBalancePrefix(address),
      exact: false,
      refetchType: "all",
    }),
    queryClient.invalidateQueries({
      queryKey: hyperliquidQueryKeys.openOrders(address, dex),
    }),
    queryClient.invalidateQueries({
      queryKey: hyperliquidQueryKeys.activeAssetPrefix(address),
      exact: false,
    }),
    queryClient.invalidateQueries({
      queryKey: hyperliquidQueryKeys.fillsPrefix(address),
      exact: false,
    }),
  ])
}
